/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
// @ts-ignore
import WaterMark from "../WaterMark";

import TermSheet from "../termSheet";
import TermSheetConfigHeader from "../termSheetConfigHeader";
import TermSheetFeeDrawer from "../termSheetFeeDrawer";
import TermsheetFooterButtonsContainer from "../termsheetFooterButtonsContainer";

const TermSheetV2 = (props) => {
  const {
    emailBodyChange,
    sanitizeCurrency,
    isTermsheetAlreadySaved,
    isDataEdited
  } = props;
  const {
    feeDetails: {
      config,
      handleAddFee,
      handleAddNewFeeConfig,
      handleVisibiltyChange,
      orgLevelFees
    },
    isViewMode,
    termSheetAction,
    showWaterMark,
    capitalizeFirstLetterOfEachWord
  } = props.termSheetConfig;
  const [openFeeDrawer, setOpenFeeDrawer] = useState(false);
  const [showFooterButtons, setShowFooterButtons] = useState(false);

  useState(() => {
    if (
      ["generate", "regenerate", "edit", "view-from-list"].includes(
        termSheetAction
      )
    ) {
      setShowFooterButtons(true);
    } else {
      setShowFooterButtons(false);
    }
  }, [termSheetAction]);

  const closeFeeDrawer = () => {
    setOpenFeeDrawer(false);
  };

  return (
    <div>
      <Modal
        open={props?.isOpenTermSheet}
        onClose={() => {
          return props.onClose();
        }}
        aria-labelledby='term-sheet-modal'
        data-testid='term-sheet-modal'
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "80%",
            height: "95%",
            bgcolor: "background.paper",
            boxShadow: 24,
            display: "flex",
            overflow: "hidden", // Prevents content from flowing outside the modal
            outline: "none", // Removes the default outline when focused
            background: "white"
          }}
        >
          {isViewMode && termSheetAction === "view" && showWaterMark && (
            <WaterMark text='INVALID  NOT FINAL' />
          )}
          <Box
            sx={{
              flex: 1
            }}
          >
            <TermSheetConfigHeader
              termSheetConfig={props?.termSheetConfig}
              onClose={props?.onClose}
            />
            <Box
              sx={{
                height: showFooterButtons ? `calc(100vh - 25%)` : "90%",
                overflowY: "auto",
                overflowX: "hidden"
              }}
            >
              <TermSheet
                termSheetData={props.termSheetData}
                setTermSheetData={props?.setTermSheetData}
                isUserConfig={props?.isUserConfig}
                termSheetConfig={props?.termSheetConfig}
                permissionsToRenderInUI={props?.permissionsToRenderInUI}
                setOpenFeeDrawer={setOpenFeeDrawer}
                openFeeDrawer={openFeeDrawer}
                termSheetAction={termSheetAction}
                triggeredSendEmail={props?.triggeredSendEmail}
                emailBodyChange={emailBodyChange}
                sanitizeCurrency={sanitizeCurrency}
                isTermsheetAlreadySaved={isTermsheetAlreadySaved}
                isDataEdited={isDataEdited}
              />
            </Box>
            {showFooterButtons ? (
              <TermsheetFooterButtonsContainer
                permissionsToRenderInUI={props.permissionsToRenderInUI}
                termSheetConfig={props.termSheetConfig}
                termSheetAction={termSheetAction}
                termSheetData={props.termSheetData}
                isTermsheetAlreadySaved={isTermsheetAlreadySaved}
                isDataEdited={isDataEdited}
              />
            ) : null}
          </Box>
          <TermSheetFeeDrawer
            open={openFeeDrawer}
            closeFeeDrawer={closeFeeDrawer}
            feeDetailsConfig={config}
            orgLevelFees={orgLevelFees}
            feeDetails={props?.termSheetData?.feeDetails}
            handleAddFee={handleAddFee}
            handleAddNewFeeConfig={handleAddNewFeeConfig}
            handleVisibiltyChange={handleVisibiltyChange}
            capitalizeFirstLetterOfEachWord={capitalizeFirstLetterOfEachWord}
          />
        </Box>
      </Modal>
    </div>
  );
};

TermSheetV2.propTypes = {
  isDataEdited: PropTypes.bool.isRequired,
  isTermsheetAlreadySaved: PropTypes.bool.isRequired,
  sanitizeCurrency: PropTypes.func.isRequired,
  emailBodyChange: PropTypes.func.isRequired,
  permissionsToRenderInUI: PropTypes.shape({
    showEmailSection: PropTypes.bool.isRequired,
    showLoanDetails: PropTypes.bool.isRequired,
    showFeeDetails: PropTypes.bool.isRequired,
    showEmailBody: PropTypes.bool.isRequired
  }).isRequired,
  termSheetConfig: PropTypes.shape({
    capitalizeFirstLetterOfEachWord: PropTypes.func.isRequired,
    feeDetails: PropTypes.shape({
      config: PropTypes.shape({}).isRequired,
      handleFeeChange: PropTypes.func.isRequired,
      handleDeleteFee: PropTypes.func.isRequired,
      handleAddFee: PropTypes.func.isRequired,
      handleAddNewFeeConfig: PropTypes.func.isRequired,
      handleVisibiltyChange: PropTypes.func.isRequired,
      orgLevelFees: PropTypes.shape({}).isRequired
    }).isRequired,
    isViewMode: PropTypes.bool.isRequired,
    termSheetAction: PropTypes.string.isRequired,
    showWaterMark: PropTypes.func.isRequired
  }).isRequired,
  isOpenTermSheet: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  termSheetData: PropTypes.shape({
    suggestedLoanTerms: PropTypes.arrayOf(PropTypes.shape({})),
    feeDetails: PropTypes.shape({})
  }),
  setTermSheetData: PropTypes.func.isRequired,
  isUserConfig: PropTypes.bool,
  triggeredSendEmail: PropTypes.bool
};

TermSheetV2.defaultProps = {
  termSheetData: {
    suggestedLoanTerms: [],
    feeDetails: {}
  }
};

TermSheetV2.defaultProps = {
  isUserConfig: false,
  triggeredSendEmail: false
};

export default TermSheetV2;
